/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Shop/Shop': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M23.846 15.53l-13.543 1.277L7.607 8h16.239v7.53zM25.596 6H6.995l-.273-.892-.006-.017A1.628 1.628 0 0 0 5.178 4H3a.249.249 0 0 0-.223.138l-.75 1.5A.25.25 0 0 0 2.25 6h2.654l5.148 16.823a.25.25 0 0 0 .239.177h13.305a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-12.01l-.686-2.241 13.372-1.26a1.634 1.634 0 0 0 1.574-1.631V6.25a.25.25 0 0 0-.25-.25zm-13.75 18A2 2 0 1 0 11.847 28 2 2 0 0 0 11.846 24m10 0A2 2 0 1 0 21.847 28 2 2 0 0 0 21.846 24"/>'
  }
})
